import React, { useEffect, useState } from 'react';
import {Link} from "react-router-dom";
import Axios from 'axios';
import { UserProvider, useUser } from '../../context/UserContext'
import notImage from "../../static/not-image.jpg"; 

let Item = ( {data} ) => {

  
  var n = Math.random();
  return (
    <div className="item">
      <figure>
        <img src={ data.img == '' || data.img == null ? notImage : data.img } alt=""/>
      </figure>
      <h2>{data.title}</h2>
      <div className="subtitle">
        Dirigido a: {data.dirigido}
      </div>
      <div className="desc">
        { data.desc !== null ? data.desc.substring(0, 60) : data.desc }
      </div>
      <Link to={"/causa/" + data.id} className="link">Ver causa</Link>
    </div>
  )
}

let Component = () => {
  const [items, setItems] = useState([]);
  const settings =  {
    arrows: false,
    arrowsBlock: false,
    autoplay: true
  };

  useEffect( () => {
    function fetchItems() {
      Axios.get(process.env.REACT_APP_API + '/api/v1/causas')
           .then( response => {
             setItems(response.data.slice(0, 3));
           })
           .catch( e => {
             console.log(e);
           })
    }
    fetchItems()
  },[]);

  return (
    <div id="carrusel">
      {items.map( (item, i) => {
        return (<Item data={item} key={item.id}/>)
      })}
    </div>
  )
}

export default Component;

export {Item};